import React, { useState, useEffect, useCallback } from 'react'
import { Card, Button, Input, InputNumber, Typography, message, Space, Divider } from 'antd'
import { SaveOutlined, GiftOutlined } from '@ant-design/icons'
import { backend } from '../../api'

const { Title, Text } = Typography

export default function ReferralConfig() {
  const [loading, setLoading] = useState(false)
  const [saving, setSaving] = useState(false)
  const [referralReward, setReferralReward] = useState('新用户注册奖励')
  const [referrerRewardDays, setReferrerRewardDays] = useState(7)
  const [referredRewardDays, setReferredRewardDays] = useState(3)

  const loadConfig = useCallback(async () => {
    setLoading(true)
    try {
      const res = await backend.adminGetReferralConfig()
      if (res.success) {
        setReferralReward(res.referralReward || '新用户注册奖励')
        setReferrerRewardDays(res.referrerRewardDays || 7)
        setReferredRewardDays(res.referredRewardDays || 3)
      }
    } catch (e) { message.error('加载失败') }
    finally { setLoading(false) }
  }, [])

  useEffect(() => { loadConfig() }, [loadConfig])

  const handleSave = async () => {
    setSaving(true)
    try {
      const res = await backend.adminUpdateReferralConfig({
        referralReward,
        referrerRewardDays,
        referredRewardDays
      })
      if (res.success) {
        message.success('推荐奖励配置已保存')
      } else {
        message.error(res.message || '保存失败')
      }
    } catch (e) { message.error('保存失败') }
    finally { setSaving(false) }
  }

  return (
    <div>
      <Title level={4}>推荐奖励配置</Title>

      <Card style={{ maxWidth: 500 }}>
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
          <div>
            <Text type="secondary" style={{ fontSize: 12 }}>奖励名称（显示在推荐记录中）</Text>
            <Input prefix={<GiftOutlined />} value={referralReward}
              onChange={e => setReferralReward(e.target.value)}
              placeholder="如：新用户注册奖励" />
          </div>

          <Divider style={{ margin: '12px 0' }} />

          <Text strong>推荐人奖励</Text>
          <div>
            <Text type="secondary" style={{ fontSize: 12 }}>推荐成功后，推荐人获得多少天会员延期</Text>
            <InputNumber min={0} max={365} value={referrerRewardDays}
              onChange={v => setReferrerRewardDays(v || 0)}
              addonAfter="天" style={{ width: '100%' }} />
          </div>

          <Text strong>被推荐人奖励</Text>
          <div>
            <Text type="secondary" style={{ fontSize: 12 }}>被推荐人（新用户）额外获得多少天会员延期</Text>
            <InputNumber min={0} max={365} value={referredRewardDays}
              onChange={v => setReferredRewardDays(v || 0)}
              addonAfter="天" style={{ width: '100%' }} />
          </div>

          <Button type="primary" icon={<SaveOutlined />} onClick={handleSave} loading={saving} block size="large">
            保存配置
          </Button>
        </Space>
      </Card>
    </div>
  )
}
